<template>
  <div>
    <b-row>
      <b-colxx xxs="12" v-if="isLoad && currentOperation">
        <h1>{{ currentOperation.description }}</h1>
        <div class="top-right-button-container">
          <b-button
            @click="editItem"
            v-b-modal.modalright
            variant="primary"
            size="lg"
            class="top-right-button"
            ref="openModal"
          >
            Editer
          </b-button>

          <b-modal
            id="modalright"
            ref="modalright"
            :title="'Editer une Operation'"
            class="modal-right"
          >
            <b-form>
              <b-form-group :label="'Description'">
                <b-form-input v-model="operation.description" />
              </b-form-group>
              <b-form-group :label="'Prix Totale'">
                <b-form-input v-model="operation.prixtotale" />
              </b-form-group>
              <b-form-group :label="'Nombre des Séances'">
                <b-form-input v-model="operation.nb_rdv" />
              </b-form-group>
            </b-form>
            <template slot="modal-footer">
              <b-button
                variant="outline-secondary"
                @click="hideModal('modalright')"
                >Annuler</b-button
              >
              <b-button variant="primary" @click="confirmEdit()" class="mr-1"
                >Confirmer</b-button
              >
            </template>
          </b-modal>
        </div>
        <b-tabs
          nav-class="separator-tabs ml-0 mb-5"
          content-class="tab-content"
          :no-fade="true"
          v-model="step"
        >
          <b-tab :title="'Détails'">
            <b-row>
              <b-colxx xxs="12" lg="4" class="mb-4">
                <b-card class="mb-0" no-body>
                  <!-- <div class="position-absolute card-top-buttons">
                    <b-button variant="outline-white" class="icon-button"><i class="simple-icon-pencil" /></b-button>
                  </div> -->
                  <!-- <img src="/assets/img/detail.jpg" alt="Detail" class="card-img-top"/> -->
                  <b-card-body>
                    <p class="text-muted text-small mb-2">{{ "Patient" }}</p>
                    <p class="mb-3">{{ currentOperation.patient.name }}</p>
                    <p class="text-muted text-small mb-2">
                      {{ "Prix Totale" }}
                    </p>
                    <p class="mb-3">{{ currentOperation.prixtotale }}</p>
                    <p class="text-muted text-small mb-2">
                      {{ "Nombre des Séances" }}
                    </p>
                    <p>{{ currentOperation.nb_rdv }}</p>
                  </b-card-body>
                </b-card>
              </b-colxx>
              <b-colxx xxs="12" lg="8">
                <b-row v-if="isLoad">
                  <b-colxx xxs="6" class="mb-4">
                    <radial-progress-card
                      :title="'Completion'"
                      :percent="completion"
                      no-suffle
                    />
                  </b-colxx>
                  <b-colxx xxs="6" class="mb-4">
                    <radial-progress-card
                      :title="'Paiement'"
                      :percent="priceGived"
                      no-suffle
                    />
                  </b-colxx>
                </b-row>
                <!-- <b-card class="mb-4" :title="$t('pages.popularity')"  v-if="isLoad">
                <div class="chart-container">
                  <area-shadow-chart :data="areaChartData" :height="300"/>
                </div>
              </b-card> -->
              </b-colxx>
            </b-row>
          </b-tab>

          <b-tab :title="'Liste des rendez-vous'">
            <b-row class="m-0">
              <div
                class="text-left mb-3 w-100"
                :class="
                  !(
                    currentOperation &&
                    currentOperation.rdvs &&
                    currentOperation.nb_rdv > currentOperation.rdvs.length
                  )
                    ? 'mb-0'
                    : ''
                "
              >
                <b-button
                  v-b-modal.modalAdd
                  variant="outline-primary"
                  @click="addRdv"
                  v-if="
                    currentOperation &&
                    currentOperation.rdvs &&
                    currentOperation.nb_rdv > currentOperation.rdvs.length
                  "
                  ><i class="simple-icon-plus btn-group-icon" />
                  {{ "Ajouter un Rendez-vous" }}</b-button
                >
                <b-modal
                  id="modalAdd"
                  ref="modalAdd"
                  :title="
                    isEdit ? 'Editer un Rendez-vous' : 'Ajouter un Rendez-vous'
                  "
                  class="modal-right"
                >
                  <b-form v-if="!isEdit">
                    <b-form-group :label="'Date'">
                      <datepicker
                        class="form-control"
                        v-model="newRdv.date"
                        :language="fr"
                      ></datepicker>
                    </b-form-group>
                    <b-form-group :label="'Heure'">
                      <el-time-select
                        v-model="newRdv.time"
                        :picker-options="{
                          start: '08:30',
                          step: '00:15',
                          end: '18:30',
                        }"
                        placeholder="Selectionner une heure"
                        class="w-100"
                      >
                      </el-time-select>
                    </b-form-group>
                  </b-form>
                  <b-form v-if="isEdit">
                    <b-form-group :label="'Date'">
                      <datepicker
                        class="form-control"
                        v-model="rdvToEdit.date"
                        :language="fr"
                      ></datepicker>
                    </b-form-group>
                    <b-form-group :label="'Heure'">
                      <el-time-select
                        v-model="rdvToEdit.heure"
                        :picker-options="{
                          start: '08:30',
                          step: '00:15',
                          end: '18:30',
                        }"
                        placeholder="Selectionner une heure"
                        class="w-100 ml-0"
                      >
                      </el-time-select>
                    </b-form-group>
                    <b-form-group :label="'Montant donné'">
                      <b-form-input
                        type="number"
                        v-model="rdvToEdit.price_gived"
                        :placeholder="$t('forms.email')"
                      />
                    </b-form-group>
                    <b-form-group :label="'Status'">
                      <switches
                        v-model="rdvToEdit.isconfirmed"
                        theme="custom"
                        color="secondary-inverse"
                        class="display-table-cell"
                      ></switches>
                    </b-form-group>
                  </b-form>
                  <template slot="modal-footer">
                    <b-button
                      variant="outline-secondary"
                      @click="hideModal('modalAdd')"
                      >Annuler</b-button
                    >
                    <b-button
                      variant="primary"
                      @click="addFinalRdv()"
                      class="mr-1"
                      >Confirmer</b-button
                    >
                  </template>
                </b-modal>
              </div>
              <b-tabs
                nav-class="separator-tabs ml-0 mb-5"
                class="w-100"
                :no-fade="true"
                v-if="
                  currentOperation &&
                  currentOperation.rdvs &&
                  currentOperation.rdvs.length
                "
              >
                <b-tab :title="`Non Traité`">
                  <b-colxx sm="12" v-if="listUntraitedRdv.length">
                    <rdv-item
                      v-for="(rdv, index) in listUntraitedRdv"
                      :key="index"
                      :data="rdv"
                      detail-path="#"
                      @changeData="changeRdv($event, rdv.id)"
                      @edit="editRdv($event, rdv.id)"
                      @delete="deleteRdv($event, rdv.id)"
                    />
                  </b-colxx>
                  <b-colxx sm="12" v-else>
                    <b-card class="w-100" no-body>
                      <b-card-body class="text-center p-4">
                        <h5 class="card-title mb-0">
                          Aucun Rendez-vous non Traité trouvé.
                        </h5>
                      </b-card-body>
                    </b-card>
                  </b-colxx>
                </b-tab>
                <b-tab :title="`Traité`">
                  <b-colxx sm="12" v-if="listTraitedRdv.length">
                    <rdv-item
                      v-for="(rdv, index) in listTraitedRdv"
                      :key="index"
                      :data="rdv"
                      detail-path="#"
                      @changeData="changeRdv($event, rdv.id)"
                      @edit="editRdv($event, rdv.id)"
                      @delete="deleteRdv($event, rdv.id)"
                    />
                  </b-colxx>
                  <b-colxx sm="12" v-else>
                    <b-card class="w-100" no-body>
                      <b-card-body class="text-center p-4">
                        <h5 class="card-title mb-0">
                          Aucun Rendez-vous Traité trouvé.
                        </h5>
                      </b-card-body>
                    </b-card>
                  </b-colxx>
                </b-tab>
              </b-tabs>
              <b-card class="w-100" v-else no-body>
                <b-card-body class="text-center p-4">
                  <h5 class="card-title mb-0">Aucun Rendez-vous trouvé.</h5>
                </b-card-body>
              </b-card>
            </b-row>
          </b-tab>

          <b-tab :title="'Pieces jointes'">
            <!-- <Attachments></Attachments> -->
            <b-row>
              <b-colxx xxs="12" md="6" lg="6" xl="3">
                <TeetsManager
                  class="mb-4"
                  @teets="getTeetsData"
                  :operation="currentOperation"
                ></TeetsManager>
              </b-colxx>
              <b-colxx xxs="12" md="6" lg="6" xl="9">
                <b-row>
                  <b-colxx class="p-2" xxs="12" md="6" lg="6" xl="3">
                    <!-- mb-4 -->
                    <div class="card upload-container w-100" @click="((!startImageProgress || imagesUploadFinished) && !loadMedia) ? openFilesChosser() : doNothing()">
                      <div v-if="(!startImageProgress || imagesUploadFinished) && !loadMedia">
                        <input type="file" ref="attachmentFile" @change="loadFiles" multiple @click="clearInput($event)" hidden>
                        <svg class="upload-container__icon" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 477.867 477.867" style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
                            <path fill="#064962" d="M324.267,221.867H256V153.6c0-9.426-7.641-17.067-17.067-17.067s-17.067,7.641-17.067,17.067v68.267H153.6
                              c-9.426,0-17.067,7.641-17.067,17.067S144.174,256,153.6,256h68.267v68.267c0,9.426,7.641,17.067,17.067,17.067
                              S256,333.692,256,324.267V256h68.267c9.426,0,17.067-7.641,17.067-17.067S333.692,221.867,324.267,221.867z"/>
                        </svg>
                      </div>
                      <div class="w-100 h-100" v-else>
                        <!-- <vue-loaders-ball-beat  /> -->
                        <vue-loaders-ball-beat class="display-table-cell upload-container__loader" v-if="loadMedia" color="#317ffe" scale="1.2"></vue-loaders-ball-beat>
                        <div class="upload-container__upload h-100" v-else>
                          <p class="upload-container__upload--text">Téléchargement ( {{currentIndex+1}} / {{images.length}} ) ...</p>
                          <b-progress style="height:28px;border: 2px solid #317ffe;" >
                            <b-progress-bar :value="images[currentIndex].progress" variant="theme-5"></b-progress-bar>
                          </b-progress>
                        </div>
                      </div>
                    </div>
                  </b-colxx>
                  <!-- mb-4  -->
                  <b-colxx class="p-2" v-for="(attach,indexAttach) in mediaListPhotos" :key="indexAttach" xxs="12" md="6" lg="6" xl="3">
                    <div class="card files__container overflow-hidden">
                      <div class="files__container--img" style="width:100%;" :style="{background:`url('${attach}')`}"></div>
                    </div>
                  </b-colxx>
                </b-row>
              </b-colxx>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-colxx>
      <div v-if="!isLoad" class="loading" key="itemLoading"></div>
      <b-card class="w-100" v-if="isLoad && !currentOperation" no-body>
        <b-card-body class="text-center p-4">
          <h5 class="card-title mb-0">Operation non trouvé.</h5>
        </b-card-body>
      </b-card>
    </b-row>
  </div>
</template>
<script>
import Vue from "vue";
import ElementUI from "element-ui";
import Datepicker from "vuejs-datepicker";
import TeetsManager from "./TeetsManager.vue";
import Attachments from "./Attachments.vue";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);
import RadialProgressCard from "@/components/Cards/RadialProgressCard";
import RdvItem from "@/components/Listing/RdvItem";
import { fr } from "vuejs-datepicker/dist/locale";

import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';

Vue.use(VueLoaders);
import "bootstrap";
import bootbox from "bootbox";

import { apiUrl } from "@/constants/config";
import Switches from "vue-switches";
export default {
  computed: {
    // priceGived() {

    // },
    droppedFiles(){
      return this.$store.getters.getDroppedFilesByType('rdv');
    },
    traitedRdvs() {
      return this.currentOperation.rdvs.filter((res) => {
        return res.isconfirmed;
      });
    },
    nonTraitedRdvs() {
      return this.currentOperation.rdvs.filter((res) => {
        let obj = res.isconfirmed;
        return !obj;
      });
    },
  },
  name: "OperationDetails",
  components: {
    RadialProgressCard,
    Datepicker,
    TeetsManager,
    Switches,
    RdvItem,
    Attachments
  },
  data() {
    return {
      isLoad: false,
      isEdit: false,
      listTraitedRdv: [],
      listUntraitedRdv: [],
      currentOperation: null,
      operation: {
        description: "",
        nb_rdv: 1,
        prixtotale: "",
      },
      newRdv: { date: new Date(), time: "" },
      fr: fr,
      rdvToEdit: null,
      completion: 0,
      priceGived: 0,
      backendUrl:apiUrl,
      images:[],
      imagesProgress:[],
      mediaListPhotos:[],
      step:0,
      listImages:[],
      startImageProgress:false,
      loadMedia:false,
      imagesUploadFinished:false,
      currentIndex:0
    };
  },
  watch: {
    droppedFiles:{
      deep:true,
      handler(){
        if(this.droppedFiles.length && this.step == 2){
          let event = {dataTransfer:{files:[...this.droppedFiles]}}
          this.onDrop(event)
        }
      }
    },
    step(){
      if(this.step == 2){
        this.$store.state.isUploadTab = true
      }
      else{
        this.$store.state.isUploadTab = false
      }
    },
    currentOperation: {
      deep: true,
      handler() {
        this.completedMeetings();
        this.genereateRdvs();
      },
    },
  },
  methods: {
    onDrop(event){
      let files = event.dataTransfer.files;
      this.loadFiles(files);
    },
    doNothing(){
      return
    },
    openFilesChosser(){
      this.$refs.attachmentFile.click()
    },
    loadFiles(data) {
      var files = null
      this.loadMedia = true
      if(data.type && data.type == "change"){
        files = this.$refs.attachmentFile.files;
      }
      else{
        files = data
      }
      if(files.length){
        for (var i = 0; i < files.length; i++) {
          // mp4|mkv|avi|
          if (!/\.(jpg|png|jpeg)$/i.test(files[i].name)) {
            // this.notify("error",this.$t('errors.file_type_not_supported'));
            this.$notify('error filled', '', "format de fichier non pris en charge, essayez les fichiers jpg, jpeg ou png.", { duration: 5000, permanent: false })
            this.loadMedia = false
            return;
          }
        }
        this.images = []
        this.saveFiles(files,0)
      }
      else{

          this.loadMedia = false
          return
      }
    },
    saveFiles(files,index){
            var file = files[index]
            var reader = new FileReader(file);
            // var formData = file
            reader.onloadend = async (event) => {
                var part = event.target.result.split(";base64,");
                var secondpart = part[0].split(":");
                if(secondpart[1].includes("image")){
                    var image = {};
                    image.name = file.name
                    image.blob = event.target.result;
                    image.size = event.total;
                    image.progress = 0;
                    image.file = file
                    image.uploaded = false;
                    image.type = secondpart[1];
                    this.images.push(image);
                    this.imagesProgress.push(0)
                }
                this.startImageProgress=false
                if(index == files.length-1){
                    this.loadMedia = false
                    this.startImageProgress=true
                }
            }
            reader.readAsDataURL(file);
            if(files[index+1]){
                setTimeout(()=>{
                    this.saveFiles(files,index+1)}
                ,800)
            }
            else{
                setTimeout(()=>{
                    this.uploadFiles()
                },1000)
            }

    },
    uploadFiles(){
      if(this.images.length){
          this.uploadImages()
      }
      if(!this.images.length){
          this.imagesUploadFinished = true
      }
    },
    async uploadImages(){
        this.startImageProgress = true
        this.imagesUploadFinished = false
        this.listImages = []
        for(var j=0;j<this.images.length;j++){
            if(!this.images[j].uploaded && !this.images[j].link && !this.images[j].started){
                this.images[j].started = true
                let images = this.images[j].file
                this.currentIndex = j
                try {
                    let endpoint = `${apiUrl}/operations/id/${this.currentOperation.id}/attachments`;
                    
                    let obj = {image:images,folder:"operations"}
                    let data = new FormData();
                    for(let key in obj){
                        data.append(key,obj[key]);
                    }

                    this.$axios.defaults.headers.common["X-Access-Token"] = this.$store.state.accessToken;
                    const resultUpload = await this.$axios.put(endpoint,data,{
                        onUploadProgress: progressEvent => {
                            if(this.images[j] && this.imagesProgress[j] !== null && this.imagesProgress[j] !== undefined  ){
                                this.imagesProgress[j] = parseInt(
                                Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                );
                                this.images[j].progress = this.imagesProgress[j]
                            }
                        }
                    })
                    delete this.$axios.defaults.headers.common["X-Access-Token"];
                    console.log("resultUpload",resultUpload)
                    if(resultUpload){
                      let result = resultUpload.data
                      this.mediaListPhotos = result
                      this.images[j].finished = true
                    }
                    else{
                      this.images[j].finished = true
                      this.images[j].failed = true
                    }
                } catch (err){
                      this.images[j].finished = true
                      this.images[j].failed = true
                    this.imagesProgress[j] = 0
                    delete this.$axios.defaults.headers.common["X-Access-Token"];
                    return err;
                }
            }
        }
        setTimeout(() => {
          for(var i=0;i<this.listImages.length;i++){
              let item = this.mediaListPhotos.findIndex(obj => parseInt(obj) == parseInt(this.listImages[i]))
              if(item == -1 ){
                  this.mediaListPhotos.unshift(this.listImages[i])
              }
          }
          this.imagesUploadFinished = true
          this.startImageProgress = false
          delete this.$axios.defaults.headers.common["X-Scalify-Token"];
        }, 3000)
    },
    clearInput(event){
      event.target.value = ""
    },
    genereateRdvs() {
      this.listTraitedRdv = [];
      this.listUntraitedRdv = [];
      for (let i = 0; i < this.currentOperation.rdvs.length; i++) {
        let item = this.currentOperation.rdvs[i];
        if (item.isconfirmed) {
          this.listTraitedRdv.push(item);
        } else {
          this.listUntraitedRdv.push(item);
        }
      }
    },
    getTeetsData(data) {
      this.currentOperation.ps = JSON.stringify(data);
    },
    completedMeetings() {
      let complete = 0;
      for (let i = 0; i < this.currentOperation.rdvs.length; i++) {
        if (this.currentOperation.rdvs[i].isconfirmed) {
          complete++;
        }
      }
      if (complete > 0) {
        this.completion = parseFloat(
          ((complete * 100) / this.currentOperation.nb_rdv).toFixed(2)
        );
      } else {
        this.completion = 0;
      }

      let price = 0;
      for (let i = 0; i < this.currentOperation.rdvs.length; i++) {
        price = price + parseFloat(this.currentOperation.rdvs[i].price_gived);
      }
      this.priceGived = parseFloat(
        ((price * 100) / this.currentOperation.prixtotale).toFixed(2)
      );
      this.$forceUpdate();
    },
    addRdv() {
      this.rdvToEdit = null;
      this.newRdv = { date: new Date(), time: "" };
      this.isEdit = false;
    },
    changeRdv(event, id) {
      let index = this.currentOperation.rdvs.findIndex(
        (obj) => obj.id == event.id
      );
      this.currentOperation.rdvs[index] = { ...event };
      this.currentOperation.rdvs[index].isconfirmed = event.isconfirmed;
      if(event.newRdv){
        this.currentOperation.rdvs.push(event.newRdv)
      }
      this.genereateRdvs();
      this.$forceUpdate();
      this.completedMeetings();
    },
    editRdv(event, id) {
      let index = this.currentOperation.rdvs.findIndex((obj) => obj.id == id);
      let item = this.currentOperation.rdvs[index];
      this.isEdit = event;
      this.rdvToEdit = { ...item };
      // this.newUser.name = item.name
      console.log("ediiiit", item);
      this.$refs.modalAdd.show();
    },
    deleteRdv(event, id) {
      let index = this.currentOperation.rdvs.findIndex((obj) => obj.id == id);
      let item = this.currentOperation.rdvs[index];
      bootbox.confirm({
        message: "Etes vous Sur ?",
        locale: "fr",
        callback: (result) => {
          if (result) {
            this.deleteCurrentRdv(item.id, index);
          }
        },
      });
    },
    deleteCurrentRdv(id, index) {
      let currentEndpoint = `${apiUrl}/rdvs`;
      this.sendRequest("delete", currentEndpoint + `/id/${id}`)
        .then((res) => {
          if (res.status == 200) {
            this.currentOperation.rdvs.splice(index);
          }
        })
        .catch((err) => {
          // this.isLoad = true;
          console.log("err", err);
        });
    },
    objectToDate(d) {
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${day}/${month}/${year}`;
    },
    addFinalRdv() {
      if (this.isEdit) {
        let obj = {
          date: this.rdvToEdit.date,
          heure: this.rdvToEdit.heure,
          isconfirmed: this.rdvToEdit.isconfirmed ? 1 : 0,
          price_gived: this.rdvToEdit.price_gived,
        };
        let currentEndpoint = `${apiUrl}/rdvs/id/${this.rdvToEdit.id}`;
        this.sendRequest("put", currentEndpoint, obj)
          .then((res) => {
            this.newRdv = { date: new Date(), time: "" };
            let index = this.currentOperation.rdvs.findIndex(
              (obj) => obj.id == res.data.id
            );
            console.log("reees ediiit", res.data, index);
            this.currentOperation.rdvs[index] = res.data;
            this.currentOperation.rdvs[index].isconfirmed = res.data.isconfirmed;
            if(res.data.newRdv){
              this.currentOperation.rdvs.push(res.data.newRdv)
            }
            this.$forceUpdate();
            this.completedMeetings();
            this.genereateRdvs();
            this.hideModal("modalAdd");
          })
          .catch((err) => {
            // this.isLoad = true;
            console.log("iam the error", err);
          });
      } else {
        let obj = {
          date: this.newRdv.date,
          heure: this.newRdv.time,
          operationId: this.currentOperation.id,
          // id_docteur: 1,
          price_gived: 0,
        };
        let currentEndpoint = `${apiUrl}/rdvs/`;
        this.sendRequest("post", currentEndpoint, obj)
          .then((res) => {
            console.log("reees add", res);
            this.newRdv = { date: new Date(), time: "" };
            this.currentOperation.rdvs.push(res.data);
            this.$forceUpdate();
            this.genereateRdvs();
            this.hideModal("modalAdd");
          })
          .catch((err) => {
            // this.isLoad = true;
            console.log("iam the error", err);
          });
      }
    },
    hideModal(refname) {
      this.$refs[refname].hide();
      this.addRdv();
    },
    editItem() {
      this.operation = { ...this.currentOperation };
    },
    confirmEdit() {
      let obj = {
        prixtotale: this.operation.prixtotale,
        nb_rdv: this.operation.nb_rdv,
        description: this.operation.description,
      };
      let currentEndpoint = `${apiUrl}/operations/id/${this.$route.params.id}`;
      this.sendRequest("put", currentEndpoint, obj)
        .then((res) => {
          console.log("reees update", res);
          if (res.data[0]) {
            this.currentOperation.prixtotale = this.operation.prixtotale;
            this.currentOperation.description = this.operation.description;
            this.currentOperation.nb_rdv = this.operation.nb_rdv;
            this.genereateRdvs();
            this.hideModal("modalright");
          }
        })
        .catch((err) => {
          // this.isLoad = true;
          console.log("iam the error", err);
        });
    },
    getOperation() {
      let currentEndpoint = `${apiUrl}/operations/id/${this.$route.params.id}`;
      this.sendRequest("get", currentEndpoint)
        .then((res) => {
          console.log("reees", res);
          if (res.data !== "") {
            this.currentOperation = res.data;
            this.operation = { ...this.currentOperation };
            this.mediaListPhotos = JSON.parse(this.currentOperation.attachments);
            this.genereateRdvs();
          }
          this.isLoad = true;
        })
        .catch((err) => {
          // this.isLoad = true;
          console.log("iam the error", err);
        });
    },
  },
  async mounted() {
    this.getOperation();
  },
};
</script>
<style lang="scss">
.overflow-hidden{
  overflow: hidden;
}
.vdp-datepicker {
  margin-left: 0;
  input {
    border: 0;
  }
}
.files__container{
  height: 100%;
  min-height:180px;
  cursor: pointer;
  border: 1px solid #DDDDDD;
  .files__container--img{
    height: 100%;
    background-color: transparent !important;
    background-size: contain !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }
}
.upload-container{
  padding:20px;
  cursor:pointer;
  border: 2px dashed #064962;
  position:relative;
  // min-height: 50%;
  min-height:180px;
  .upload-container__icon{
    display: block;
    width:75%;
    height:75%;
    margin:auto;
  }
  .upload-container__loader{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%) scale(1.2) !important;
  }
  .upload-container__upload{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%) !important;
    width: calc(100% - 40px);
    max-height: calc(100% - 40px);
    .upload-container__upload--text{
      font-weight: bold;
      text-align: center;
      font-size: 16px;
    }
  }
}
</style>
